import { getKyClient } from './client';

export const fetchCustomerAccounts = async (searchText, dob) => {
  let url = `v1.0/accounts?basicSearch=`;
  url += searchText || 'empty';
  url += '&dob=' + (dob || 'empty');
  const kyClient = await getKyClient();
  return kyClient.get(url).json();
};
